import * as React from "react"

const Backpack = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" {...props}>
    <path d="M37 43a1 1 0 0 1-2 0v-2H20v9a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-9h-7zm5-7H22a2 2 0 0 0-2 2v1h24v-1a2 2 0 0 0-2-2z" />
    <path d="M32 13a19 19 0 0 0-19 19v21a4 4 0 0 0 4 4h30a4 4 0 0 0 4-4V32a19 19 0 0 0-19-19zm14 37a4 4 0 0 1-4 4H22a4 4 0 0 1-4-4V38a4 4 0 0 1 4-4h20a4 4 0 0 1 4 4zm0-17a1 1 0 0 1-1-1 13 13 0 0 0-26 0 1 1 0 0 1-2 0 15 15 0 0 1 30 0 1 1 0 0 1-1 1zM32 8a4 4 0 0 1 4 3.37 20.23 20.23 0 0 1 2 .5 6 6 0 0 0-12 0 17.85 17.85 0 0 1 2-.5A4 4 0 0 1 32 8zM7 40v1h4v-4h-1a3 3 0 0 0-3 3zm0 7a6 6 0 0 0 4 5.65V43H7zm47-10h-1v4h4v-1a3 3 0 0 0-3-3zm-1 15.65A6 6 0 0 0 57 47v-4h-4z" />
  </svg>
)

export default Backpack
